import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "alert-circle",
  "use": "alert-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"alert-circle\"><g fill=\"none\" stroke=\"#b54a42\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\"><circle cx=\"12\" cy=\"12\" r=\"10\" /><path d=\"M12 8v4m0 4h.01\" /></g><path fill=\"rgba(0, 0, 0, 0)\" d=\"M0 0h24v24H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol